class BuyNowButton extends HTMLElement {
    constructor() {
      super();
  
      this.button = this.querySelector('.ug-buyNow-bth');
      this.quantityInput = this.querySelector('[data-quantity-value]');
      this.init();
    }
  
    init() {
      if (this.button) {
        this.button.addEventListener('click', this.handleClick.bind(this));
      }
    }
  
    getProductData() {
      return {
        variantId: this.button?.getAttribute('data-variant-id') || this.getAttribute('data-variant-id'),
        productHandle: this.button?.getAttribute('data-product-handle') || this.getAttribute('data-product-handle'),
        productId: this.button?.getAttribute('data-product-id') || this.getAttribute('data-product-id')
      };
    }
  
  
    setLoadingState(button, isLoading) {
      const spinner = button.querySelector('.loading__spinner');
      const buttonText = button.querySelector('.button-text');
  
      if (isLoading) {
        button.classList.add('loading');
        button.setAttribute('aria-disabled', true);
        spinner?.classList.remove('hidden');
        buttonText?.classList.add('hidden');
      } else {
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
        spinner?.classList.add('hidden');
        buttonText?.classList.remove('hidden');
      }
    }
  
    async clearCart() {
      const response = await fetch('/cart/clear.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
      });
  
      if (!response.ok) {
        throw new Error('Failed to clear cart');
      }
  
      return response;
    }
  
    async addToCart(variantId, quantity = 1) {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: quantity,
            },
          ],
        }),
      });
  
      if (!response.ok) {
        throw new Error('Failed to add to cart');
      }
  
      return response;
    }
  
    async processCheckout(button, variantId) {
      try {
        this.setLoadingState(button, true);
        // 获取数量
        const useQuantityInput = button.hasAttribute('data-quantity-control');
        const quantity = useQuantityInput
          ? parseInt(this.quantityInput?.value || 1, 10)
          : 1;
  
        await this.clearCart();
        await this.addToCart(variantId, quantity);
        
        this.redirectToCheckout();
  
      } catch (error) {
        console.error('Checkout error:', error);
        this.handleError('There was an error processing your request. Please try again.');
      } finally {
        this.setLoadingState(button, false);
      }
    }
  
    async handleClick(event) {
      event.preventDefault();
      
      const button = event.currentTarget;
      const productData = this.getProductData();
      
      console.log('Checkout attempt with:', productData);
  
      const checkoutVariantId = productData.variantId;
  
      if (checkoutVariantId) {
        await this.processCheckout(button, checkoutVariantId);
      } else if (productData.productHandle) {
        this.redirectToProduct(productData.productHandle);
      } else {
        this.handleError("Sorry, we couldn't find the product information. Please try another product.");
      }
    }
  
    redirectToCheckout() {
      window.location.href = '/checkout';
    }
  
    redirectToProduct(productHandle) {
      window.location.href = '/products/' + productHandle;
    }
  
    handleError(message) {
      console.error(message);
      alert(message);
    }
  
  }
  
  customElements.define('buy-now-button', BuyNowButton);
  
  // 引用
  {/* <buy-now-button>
    <input class="quantity__input" type="number" value="1" min="1">
    <button class="buy_now" data-variant-id="123" data-quantity-control>
      <span class="button-text">Buy Now</span>
    </button>
  </buy-now-button> */}